import { getFillByLot } from "../manzanas/Manzana2Div1";

export const Manzana30Div1M2 = ({
  lands,
  landSelector = (_e, _id) => {},
  selected,
  style,
}) => {
  const findLandByLot = (lot) => {
    return lands.filter((l) => l.lote === lot)[0];
  };

  if (!lands) {
    return <></>;
  }

  return (
    <svg 
    width={style?.width || "1219"}
    height={style?.height || "941"}
    viewBox="0 0 1221 921" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg">
  <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("1"))}
    
    fill={getFillByLot(1, selected, lands)}  />
  <rect width="1221" height="921" fill="url(#pattern0_1468_40534)"/>
<path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("1"))}
    d="M342.895 393.797C335.994 373.092 353.44 371.75 363.025 373.668L475.175 471.44L409.034 520.326C389.863 486.777 349.797 414.502 342.895 393.797Z" 
    fill={getFillByLot(1, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
<path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("2"))}
    d="M535.569 520.326L475.18 471.439L409.039 520.326C417.666 538.539 436.646 577.265 443.547 586.467C452.174 597.97 475.18 592.218 478.056 580.716C480.931 569.213 495.31 551.959 512.564 546.207C526.367 541.606 533.652 527.036 535.569 520.326Z" 
    fill={getFillByLot(2, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
<defs>
    <pattern id="pattern0_1468_40534" patternContentUnits="objectBoundingBox" width="1" height="1">
    <use href="#image0_1468_40534" transform="matrix(0.00394449 0 0 0.00522933 -6.76355 -2.43993)"/>
    </pattern>
    <image id="image0_1468_40534" width="4096" height="2304" href="/mz2.png"/>
    </defs>
</svg>

  );
};